import { LayoutFunctions } from "@/3d/area/LayoutFunctions";
import { DEFAULT_DOOR_PROPS, DEFAULT_WINDOW_PROPS, WallKey } from "./RoomConfig";
import { RoomConfig } from "./RoomConfig";
import {
    getWallPropAreaConfig,
    getWallPropSpace,
    WALL_PROP_COLORS,
    WallPropConfig,
} from "./WallConfig";
import { AreaConfig } from "@/3d/area/AreaConfig";
import { getWallSizePropForWallKey } from "./RoomConfig";
import { Space } from "@/3d/area/AreaLayout";
import { v4 as uuidv4 } from "uuid";
import { round } from "lodash";

export const WINDOW_DEFAULT_FLOOR_OFFSET = 0.7;
const PROP_CEILING_OFFSET = 0.2;
const PROP_SPACING = 0.1;

export const createWallProp = (
    type: WallPropConfig["type"],
    width: number,
    wallKey: WallKey,
    roomConfig: RoomConfig
): undefined | WallPropConfig => {
    const sizeProp = getWallSizePropForWallKey(wallKey);
    const size = roomConfig[sizeProp];

    const propAreaConfig: AreaConfig = getWallPropAreaConfig(width);

    const wallSpace: Space = {
        type: "1axis",
        start: 0,
        end: size,
        size,
    };

    const existingPropSpaces = roomConfig[wallKey].props.map(getWallPropSpace);

    const freeSpace = LayoutFunctions["1axis"].getFreeSpaceForConfig(
        wallSpace,
        existingPropSpaces,
        propAreaConfig
    );

    if (!freeSpace) {
        return undefined;
    }

    const propIndex = roomConfig[wallKey].props.filter((prop) => prop.type === type).length;

    if (type === "window") {
        const windowHeightRelativeToRoomHeight = round(
            roomConfig.height - PROP_CEILING_OFFSET - WINDOW_DEFAULT_FLOOR_OFFSET,
            3
        );

        return {
            type,
            width,
            height: Math.min(windowHeightRelativeToRoomHeight, DEFAULT_WINDOW_PROPS.height),
            floorOffset: round(WINDOW_DEFAULT_FLOOR_OFFSET, 3),
            offset: round(freeSpace.start + PROP_SPACING, 3),
            key: uuidv4(),
            highlightColor: WALL_PROP_COLORS[propIndex % WALL_PROP_COLORS.length],
        };
    }

    return {
        type,
        width,
        height: Math.min(
            round(roomConfig.height - PROP_CEILING_OFFSET, 3),
            DEFAULT_DOOR_PROPS.height
        ),
        offset: round(freeSpace.start + PROP_SPACING, 3),
        key: uuidv4(),
        highlightColor: WALL_PROP_COLORS[propIndex % WALL_PROP_COLORS.length],
    };
};
